import React, { useEffect, useState } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import AddWebsiteModalForm from "../Website/AddWebsiteModelForm";
import AdstxtModalForm from "../Website/AdstxtWebsite";
import WebsiteApiService from '../../ApiServices/WebsiteApiService/WebsiteApiService';
import AppApiService from '../../ApiServices/WebsiteApiService/AppApiService';
import adsTxtApiService from '../../ApiServices/AdsTxtApiService/AdTxtApiService';
import { useAuth } from "../Auth/AuthContext";
import { useNavigate } from "react-router-dom";
import { FaChartLine, FaFileDownload, FaPlusCircle } from "react-icons/fa";

export default function TextCard() {
    const { authState } = useAuth();
    const user = authState.user;
    const role = authState.roles;
    const admin = role === "Admin";

    const [openModal, setOpenModal] = useState(false);
    const [openAdsModal, setOpenAdsModal] = useState(false);
    const [websiteDataArray, setWebsiteDataArray] = useState([]);
    const [appDataArray, setAppDataArray] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });

        const fetchData = async () => {
            try {
                const websiteData = admin
                    ? await WebsiteApiService.Get()
                    : await WebsiteApiService.GetAllWebByUserId(user.id);

                const appData = admin
                    ? await AppApiService.Get()
                    : await AppApiService.GetAllAppByUserId(user.id);

                setWebsiteDataArray(Array.isArray(websiteData.data) ? websiteData.data : [websiteData.data]);
                setAppDataArray(Array.isArray(appData.data) ? appData.data : [appData.data]);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [admin, user.id]);

    const handleDownload = async () => {
        await adsTxtApiService.DownloadAdFile("AdTxt");
    };

    const handleWebAnalytics = () => navigate("/webanalytics");
    const handleAppAnalytics = () => navigate("/appanalytics");

    return (
        <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="bg-white/50 backdrop-blur-md border border-gray-200 rounded-2xl shadow-xl p-8 mt-10 transition-all duration-300"
        >
            <h2 className="text-xl font-bold text-gray-800 mb-6 text-center">
                Quick Actions
            </h2>

            {/* Buttons */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <ActionButton
                    onClick={handleWebAnalytics}
                    label="Web Analytics"
                    icon={<FaChartLine className="text-lg group-hover:scale-125 transition-transform duration-200" />}
                    color="bg-indigo-600 hover:bg-indigo-700"
                />
                <ActionButton
                    onClick={handleAppAnalytics}
                    label="App Analytics"
                    icon={<FaChartLine className="text-lg group-hover:scale-125 transition-transform duration-200" />}
                    color="bg-emerald-600 hover:bg-emerald-700"
                />
                <ActionButton
                    onClick={() => setOpenModal(true)}
                    label="Add App/Website"
                    icon={<FaPlusCircle className="text-lg group-hover:rotate-90 transition-transform duration-300" />}
                    color="bg-rose-600 hover:bg-rose-700"
                />
            </div>

            {/* Modals */}
            <AddWebsiteModalForm isOpen={openModal} closeModal={() => setOpenModal(false)} />
            <AdstxtModalForm isOpen={openAdsModal} closeModal={() => setOpenAdsModal(false)} />
        </div>
    );
}

// Sub-component for buttons
const ActionButton = ({ onClick, label, icon, color }) => (
    <button
        onClick={onClick}
        className={`group flex items-center justify-center gap-2 ${color} text-white font-semibold py-3 px-4 rounded-xl shadow-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl`}
    >
        {icon}
        <span>{label}</span>
    </button>
);
